import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import qs from 'query-string';

import CheckboxIcon from '../../../../../../../../../components/icons/CheckboxIcon';
import Button from '../../../../../../../../../components/global/Button';
import ShoppingBasketIcon from '../../../../../../../../../components/icons/ShoppingBasketIcon';
import { getAlbumMembershipGroupGreenScreenStatus } from '../../../PurchasingOptions/helpers';

const propTypes = {
  photoIds: PropTypes.arrayOf(PropTypes.string),
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onCheckout: PropTypes.func,
};

const DigitalBundleConfigurationComplete = ({
  photoIds,
  albumMembershipGroup,
  onClose,
  onCheckout,
}) => {
  const history = useHistory();
  const cart = useSelector(({ checkout }) => checkout.cart);
  const hasCheckoutAction = cart.length > 0 && onCheckout;
  const isGreenScreenEnabled = getAlbumMembershipGroupGreenScreenStatus(
    albumMembershipGroup,
  );

  return (
    <div>
      <div className="d-flex align-items-center mb-2">
        <h3 className="w-100 text-center mb-0">
          Your selected {pluralize('photo', photoIds?.length ?? 0)} can now be
          downloaded!
        </h3>
      </div>

      <div className="d-flex align-items-center mb-2">
        {hasCheckoutAction && (
          <span>
            <CheckboxIcon size={24} />
          </span>
        )}
        <p
          className={classNames({
            'mb-0': true,
            'ml-1': hasCheckoutAction,
            'd-none': !hasCheckoutAction,
          })}
        >
          Remember to go through checkout below to finalize your prints order.
        </p>
      </div>

      {hasCheckoutAction && (
        <Button
          btnStyle="success-vibrant"
          btnBlock
          onClick={() => {
            onCheckout();
            onClose();
          }}
          className="btn-checkout-print-product-size-success"
        >
          <ShoppingBasketIcon /> Checkout now
        </Button>
      )}
      {isGreenScreenEnabled && (
        <Button
          btnBlock
          onClick={() => {
            history.push({
              pathname: `/cards/downloads-configurator/${albumMembershipGroup.id}`,
              search: `?${qs.stringify(
                {
                  photoIds,
                },
                { arrayFormat: 'bracket' },
              )}`,
            });
            onClose?.();
          }}
        >
          Configure your photos now!
        </Button>
      )}
      <Button btnOutline btnBlock onClick={onClose}>
        Return to Photos
      </Button>
    </div>
  );
};

DigitalBundleConfigurationComplete.propTypes = propTypes;

export default DigitalBundleConfigurationComplete;
